import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=08d89c2a"
import script from "./Recorder.vue?vue&type=script&lang=js"
export * from "./Recorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports